/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Group_WeekInputs */

const vi_report_group_week = /** @type {(inputs: Report_Group_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuần`)
};

/**

* @param {Report_Group_WeekInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_group_week = /** @type {((inputs?: Report_Group_WeekInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Group_WeekInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_group_week(inputs)
});